import { createContext } from 'react';

const xrayContext = createContext();

export default xrayContext;
